import eventEditComponent from './event-edit.component';

const eventEditModule = angular.module('eventEdit', [
])
  .component('eventEdit', eventEditComponent)
  .name;

export default eventEditModule;
